import classNames from "classnames";
import { uniqueId } from "lodash";
import { Component } from "react";
import { RouteComponentProps } from "react-router";
import { AdequacyAggregateType, NetworkProviderFilterType } from "@app/exports/enumerations";
import { NetworkAssessmentAnalysisType } from "@app/projects/enumerators";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import SharedUsers from "@app/reports/SharedUsers";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";

interface GenerateBodyProps extends RouteComponentProps<unknown> {
  emailOnSuccess: boolean;
  isLoading: boolean;
  isValid: boolean;
  onEmailOnSuccessChange: (emailOnSuccess: boolean) => void;
  onGenerateClick: () => Promise<void>;
  onReportNameChange: (reportName: string) => void;
  reportName: string;
  showSharedUsers?: boolean;
  sharedUsers?: number[];
  updateSelectedSharedUsers?: (sharedUsers: number[]) => void;
  exportType?: string;
  projectId?: number;
  networkAssessmentAnalysisType?: NetworkAssessmentAnalysisType;
  networkProviderFilterType?: NetworkProviderFilterType;
  aggregateType?: AdequacyAggregateType;
}

export default class GenerateBody extends Component<GenerateBodyProps> {
  private readonly reportNameId = uniqueId("export-data-control-");

  public render() {
    const isFileNameOk = this.props.reportName && this.props.reportName.length > 0 && this.props.reportName.length < 255;
    const hasError = !isFileNameOk;
    const isValid = isFileNameOk && this.props.isValid;
    const emailId = uniqueId("email-me");

    return (
      <>
        <hr />
        <div className="row">
          <div className="col-12">
            <div className={classNames("d-inline-flex align-items-center", { "has-error": hasError })}>
              <QESTextInput
                className=""
                testId={`search-checkbox-dropdown__report-name-input`}
                label="Report Name:"
                value={this.props.reportName}
                onChange={(e) => this.props.onReportNameChange(e.target.value)}
                containerClassName="checkbox-dropdown__label ps-0"
              />

              {isFileNameOk ? (
                <>
                  {this.props.showSharedUsers &&
                      <SharedUsers
                        exportType={this.props.exportType}
                        customProjectIds={[this.props.projectId]}
                        tooltipTitle="Users in this list have been filtered to only show users with access to this project and information in this report"
                        networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                        networkProviderFilterType={this.props.networkProviderFilterType}
                        aggregateType={this.props.aggregateType}
                        updateSelectedSharedUsers={this.props.updateSelectedSharedUsers}
                        sharedUsersFilter={this.props.sharedUsers}
                      />
                  }
                  <QESCheckbox
                    containerClassName="ms-2 demibold"
                    label={<>
                      <QesIcon iconName={QesIcons.MailV1} description="Mail" className="align-text-top me-2" />
                      Yes, please email me {(!this.props.sharedUsers || this.props.sharedUsers?.length === 0) ? "" : `and the other user${this.props.sharedUsers?.length > 1 ? "s": ""}`} a link to the report when ready.
                    </>}
                    id={emailId}
                    className="me-2"
                    checked={this.props.emailOnSuccess}
                    onChange={(e) => this.props.onEmailOnSuccessChange(e.target.checked)}
                    testId="generate-body__email-on-success"
                  />
                </>
              ) : (
                <label className="ms-2 text-danger"> Invalid report name, please enter a name between 1 and 255 characters.</label>
              )}
            </div>
            <div className="form-row align-items-center mt-3">
              <div className="col-12">
                {this.props.isLoading ? (
                  <QESButton qesTestId="generate-body_generating" qesType="primary" disabled className="me-2">
                    <QesIcon iconName={QesIcons.LoadingV1} description="Loading" className="qes-icon-spin align-text-top me-1" /> Generating...
                  </QESButton>
                ) : (
                  <QESButton
                    qesTestId="generate-body_generate"
                    qesType="primary"
                    disabled={!isValid}
                    className="me-2"
                    onClick={this.props.onGenerateClick}
                  >Generate</QESButton>
                )}

                {!isValid && (
                  <span className="ms-2 text-danger">
                    <QesIcon iconName={QesIcons.AlertTriangle} description="Alert" className="align-text-top me-1" /> Current filter selections will not yield a result!
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
